import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22f49587"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Let op:"),
    /*#__PURE__*/_createTextVNode(" Stel je Verbeterchecks veilig!")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Dit platform maakt volgend jaar plaats voor een verbeterde versie. Download op tijd al je ingevulde Verbeterchecks en het Gevaarlijkestoffenregister. Lees meer op "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.5xbeter.nl/site/nl/over-5xbeter/nieuw-platform-5xbeter",
      target: "_blank"
    }, "5xbeter.nl/site/nl/over-5xbeter/nieuw-platform-5xbeter"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import NoticeBar from '@/components/NoticeBar.vue';
	import {useStore} from 'vuex';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'Backup-your-checks-notice',
  setup(__props) {


	const store = useStore();
	const close = () => store.commit('closeBackupNotification');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NoticeBar, { style: {"margin-top":"-24px","margin-bottom":"24px"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "notice-container" }, [
        _hoisted_1,
        _createElementVNode("div", { class: "close-button" }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            onClick: close
          }, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})